module.exports = __webpack_public_path__ + "static/media/teleport_logo.e663724a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/teleport_logo.svg
// module id = 119
// module chunks = 0